import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { MainHead } from '../../../components/common/head/MainHead';
import { newProductPageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useGetNewProductsQuery } from '../../../hooks/api/useGetNewProducts.query';
import { useGetBannersQuery } from '../../../hooks/banners/queries/useGetBanners.query';
import { useLayout } from '../../../hooks/screen/useLayout';
import { INewProduct } from '../../../interfaces/NewProduct.interfaces';
import { NewProductDetailCard } from '../../../views/Product/listView/NewProductDetailCard/NewProductDetailCard';
import { MainCarousel } from '../../Home/HomePage/components/MainCarousel';

export const NewProductListPage = () => {
  const { data: mainCarouselImages, isLoading: isGetMainCarouselImagesQueryLoading } = useGetBannersQuery({
    searchParam: {
      category: 'CAROUSEL_MAIN',
      outputLocation: 'new-product',
    },
  });

  const { data: newProducts, isLoading: isGetNewProductsQueryLoading } = useGetNewProductsQuery({
    options: {
      select: (data) => {
        return data.filter((product) => product.status !== 'PENDING');
      },
    },
  });

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: false }} headerTitle={'신품관'} hasMyInfoButton />,
    fixedHeaderHeight: 48,
    fixedFooter: undefined,
    fixedFooterHeight: 0,
    style: { background: '#fff' },
  });

  return (
    <>
      <Helmet>
        <title>{`${newProductPageInfo.listPage.title} - Pluva Market`}</title>
      </Helmet>
      <Container>
        {mainCarouselImages && mainCarouselImages.length > 0 && (
          <MainCarousel carouselImages={mainCarouselImages} pageType={'new-product'} position={'top'} />
        )}
        <ProductContainer>
          {newProducts?.map((product) => (
            <NewProductDetailCard key={product.id} product={product as INewProduct} section={'new-product-list'} />
          ))}
        </ProductContainer>
      </Container>
    </>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
`;

const ProductContainer = styled.div`
  display: flex;
  padding: 24px 16px 32px 16px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
`;
